import React from "react";
import { CardSection, FlexedData, ServiceMain } from "../../styles/services";

const Services = () => {
  return (
    <ServiceMain>
      <div className="header">
        <div className="box_header">
          <div className="box" />
          <div className="box" />
          <div className="box" />
          <div className="box" />
        </div>
        <h2 className="header_text">Move faster. Think bigger.</h2>
      </div>
      <div>

        {
          data.map((item, index) => (
            <FlexedData>
              <section>
                <CardSection>
                  <div>
                    <h3>{item.header}</h3>
                  </div>

                  <p>
                    {item.text}
                  </p>
                </CardSection>
                <CardSection>
                  <div className="img_container">
                    <div className="hero3">
                      <img  loading ="lazy" src={item.img} alt="sixth"></img>

                    </div>
                  </div>
                </CardSection>
              </section>
            </FlexedData>
          )


          )
        }
      </div>
      <div className="empty">

      </div>
    </ServiceMain>
  );
};

export default Services;

const data = [
  {
    header: "Deep Planning Mode",
    text: "Deep Planning Mode builds a step‑by‑step strategy before coding, ensuring the agent codes right, not just fast",
    img: "https://raw.githubusercontent.com/precious112/Pstore_backend/refs/heads/master/media/media/sixth-ai_docs_edit_2-ezgif.com-optimize.gif",
  },
  {
    header: "Sub-Agents for Parallel Work",
    text: "Sixth AI launches sub‑agents to tackle tasks in parallel — researching, writing, and validating at once.",
    img: "https://raw.githubusercontent.com/precious112/Pstore_backend/refs/heads/master/media/media/sixth_ai_docs_edit_3-ezgif.com-optimize.gif",
  },
  {
    header: "Remote Control",
    text: "Start on PC, steer via Telegram — Sixth AI’s remote access lets you monitor, approve, and control tasks from your phone.",
    img: "https://raw.githubusercontent.com/precious112/Pstore_backend/refs/heads/master/media/media/IMG_2929.png",
  },
];
